import React from 'react';
import {
  Clock,
  CircleCheck,
  CircleAlert,
  CircleDashed,
  Ban,
  AlarmClock,
  LoaderCircle,
  FileText,
} from 'lucide-react';
import type { InvoiceUnifiedStatus } from '@hero/api';
import { getIconProps, IconProps } from '../utils/props';

export const InvoiceIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <FileText {...iconProps} />;
};
/** On-going invoice status icon (active/in progress) */
export const InvoiceStatusOnGoingIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <LoaderCircle {...iconProps} />;
};

/** Paid invoice status icon */
export const InvoiceStatusPaidIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <CircleCheck {...iconProps} />;
};

/** Not paid invoice status icon */
export const InvoiceStatusNotPaidIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <CircleAlert {...iconProps} />;
};

/** Partially paid invoice status icon */
export const InvoiceStatusPartiallyPaidIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <CircleDashed {...iconProps} />;
};

/** Pending invoice status icon (awaiting action) */
export const InvoiceStatusPendingIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Clock {...iconProps} />;
};

/** Cancelled invoice status icon */
export const InvoiceStatusCancelledIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Ban {...iconProps} />;
};

/** Not paid or partial (unified) invoice status icon */
export const InvoiceStatusNotPaidOrPartialIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <CircleAlert {...iconProps} />;
};

/** Overdue invoice status icon */
export const InvoiceStatusOverdueIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <AlarmClock {...iconProps} />;
};

/**
 * Dynamic invoice status icon component.
 * Takes an invoice status and returns the appropriate icon.
 */
export const InvoiceStatusDynamicIcon: React.FC<
  IconProps & { status: InvoiceUnifiedStatus }
> = props => {
  const { status, ...rest } = props;

  switch (status) {
    case 'on_going':
      return <InvoiceStatusOnGoingIcon {...rest} />;
    case 'paid':
      return <InvoiceStatusPaidIcon {...rest} />;
    case 'not_paid':
      return <InvoiceStatusNotPaidIcon {...rest} />;
    case 'partially_paid':
      return <InvoiceStatusPartiallyPaidIcon {...rest} />;
    case 'pending':
      return <InvoiceStatusPendingIcon {...rest} />;
    case 'cancelled':
      return <InvoiceStatusCancelledIcon {...rest} />;
    case 'not_paid_or_partial':
      return <InvoiceStatusNotPaidOrPartialIcon {...rest} />;
    case 'overdue':
      return <InvoiceStatusOverdueIcon {...rest} />;
    default:
      return <InvoiceStatusPendingIcon {...rest} />;
  }
};
